/**
 * Registro global de trabalho em memória que seria perdido com um reload.
 *
 * A atualização automática de build (`useAppUpdateCoordinator`) consulta este
 * registro antes de recarregar a página: enquanto houver trabalho protegido,
 * o reload fica pendente em vez de descartar dados do operador.
 */

type ProtectedWorkListener = (active: boolean) => void;

let activeCount = 0;
const listeners = new Set<ProtectedWorkListener>();

function notifyListeners() {
  const active = activeCount > 0;
  listeners.forEach((listener) => listener(active));
}

export function isProtectedWorkActive(): boolean {
  return activeCount > 0;
}

export function subscribeProtectedWork(
  listener: ProtectedWorkListener,
): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

/**
 * Registra uma unidade de trabalho protegido. Chame a função devolvida assim
 * que o trabalho terminar, for cancelado ou voltar a um estado seguro.
 */
export function registerProtectedWork(): () => void {
  activeCount += 1;
  notifyListeners();

  let released = false;
  return () => {
    if (released) return;
    released = true;
    activeCount = Math.max(0, activeCount - 1);
    notifyListeners();
  };
}
